/*
 * Winners Furniture — "Plum Atelier" motion engine
 * Char-split hero reveal, scroll reveals, pointer tilt, spotlight borders,
 * animated counters, magnetic CTA, scroll progress. All transform/opacity,
 * all gated behind prefers-reduced-motion.
 */
(function () {
  "use strict";

  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia("(pointer: fine)").matches;

  /* ---------- char-split headline (hero) ---------- */
  function splitChars() {
    document.querySelectorAll("[data-wf-split]").forEach(function (el) {
      if (el.dataset.wfSplitDone) return;
      var ci = 0;
      function walk(node) {
        Array.prototype.slice.call(node.childNodes).forEach(function (child) {
          if (child.nodeType === 3) {
            var frag = document.createDocumentFragment();
            child.textContent.split(/(\s+)/).forEach(function (word) {
              if (!word) return;
              if (/^\s+$/.test(word)) { frag.appendChild(document.createTextNode(" ")); return; }
              var w = document.createElement("span");
              w.className = "wf-word";
              word.split("").forEach(function (ch) {
                var s = document.createElement("span");
                s.className = "wf-char";
                s.style.setProperty("--ci", ci++);
                s.textContent = ch;
                w.appendChild(s);
              });
              frag.appendChild(w);
            });
            node.replaceChild(frag, child);
          } else if (child.nodeType === 1) walk(child);
        });
      }
      if (!reduce) walk(el);
      el.classList.add("wf-split");
      el.dataset.wfSplitDone = "1";
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add("is-in"); });
      });
    });
  }

  /* ---------- scroll reveals ---------- */
  function reveals() {
    // product cards and section headers animate in on every page
    document.querySelectorAll(".main-content .grid-product, .main-content .section-header").forEach(function (el) {
      el.classList.add("wf-reveal");
    });
    var els = document.querySelectorAll(".wf-reveal");
    if (!els.length) return;
    if (reduce || !("IntersectionObserver" in window)) {
      els.forEach(function (el) { el.classList.add("is-in"); });
      return;
    }
    var byParent = new Map();
    els.forEach(function (el) {
      var list = byParent.get(el.parentElement) || [];
      list.push(el);
      byParent.set(el.parentElement, list);
    });
    byParent.forEach(function (list) {
      list.forEach(function (el, i) {
        if (!el.style.transitionDelay) el.style.transitionDelay = Math.min(i * 110, 550) + "ms";
      });
    });
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); }
      });
    }, { threshold: 0.18, rootMargin: "0px 0px -8% 0px" });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- pointer tilt (hero visual) ---------- */
  function tilt() {
    if (reduce || !fine) return;
    document.querySelectorAll("[data-wf-tilt]").forEach(function (wrap) {
      var target = wrap.querySelector(".wf-hero__visual") || wrap;
      var rx = 0, ry = 0, trx = 0, try_ = 0, raf = null;
      function loop() {
        rx += (trx - rx) * 0.09;
        ry += (try_ - ry) * 0.09;
        target.style.transform = "perspective(1100px) rotateX(" + rx + "deg) rotateY(" + ry + "deg)";
        if (Math.abs(trx - rx) > 0.01 || Math.abs(try_ - ry) > 0.01) raf = requestAnimationFrame(loop);
        else raf = null;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }
      wrap.addEventListener("pointermove", function (e) {
        var r = wrap.getBoundingClientRect();
        try_ = ((e.clientX - r.left) / r.width - 0.5) * 8;
        trx = -((e.clientY - r.top) / r.height - 0.5) * 8;
        kick();
      });
      wrap.addEventListener("pointerleave", function () { trx = 0; try_ = 0; kick(); });
    });
  }

  /* ---------- spotlight border tracking (bento) ---------- */
  function spotlight() {
    if (!fine) return;
    document.querySelectorAll(".wf-bento__cell").forEach(function (cell) {
      cell.addEventListener("pointermove", function (e) {
        var r = cell.getBoundingClientRect();
        cell.style.setProperty("--mx", (e.clientX - r.left) + "px");
        cell.style.setProperty("--my", (e.clientY - r.top) + "px");
      });
    });
  }

  /* ---------- animated counters ---------- */
  function counters() {
    var els = document.querySelectorAll("[data-wf-count]");
    if (!els.length) return;
    function run(el) {
      var target = parseFloat(el.getAttribute("data-wf-count")) || 0;
      var suffix = el.getAttribute("data-wf-suffix") || "";
      if (reduce) { el.childNodes[0].textContent = target + suffix; return; }
      var t0 = null;
      function step(ts) {
        if (t0 === null) t0 = ts;
        var p = Math.min((ts - t0) / 1400, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.childNodes[0].textContent = Math.round(target * eased) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
    }
    if (!("IntersectionObserver" in window)) { els.forEach(run); return; }
    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { run(e.target); obs.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- magnetic CTA ---------- */
  function magnetic() {
    if (reduce || !fine) return;
    document.querySelectorAll(".wf-btn").forEach(function (btn) {
      var x = 0, y = 0, tx = 0, ty = 0, raf = null;
      function loop() {
        x += (tx - x) * 0.14;
        y += (ty - y) * 0.14;
        btn.style.transform = "translate(" + x + "px," + y + "px)";
        if (Math.abs(tx - x) > 0.05 || Math.abs(ty - y) > 0.05) raf = requestAnimationFrame(loop);
        else raf = null;
      }
      function kick() { if (!raf) raf = requestAnimationFrame(loop); }
      btn.addEventListener("pointermove", function (e) {
        var r = btn.getBoundingClientRect();
        tx = (e.clientX - r.left - r.width / 2) * 0.22;
        ty = (e.clientY - r.top - r.height / 2) * 0.22;
        kick();
      });
      btn.addEventListener("pointerleave", function () { tx = 0; ty = 0; kick(); });
    });
  }

  /* ---------- scroll progress ---------- */
  function progress() {
    if (reduce) return;
    var bar = document.createElement("div");
    bar.id = "wf-progress";
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var max = document.documentElement.scrollHeight - document.documentElement.clientHeight;
      bar.style.transform = "scaleX(" + (max > 0 ? window.scrollY / max : 0) + ")";
      ticking = false;
    }
    window.addEventListener("scroll", function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  function init() {
    splitChars();
    reveals();
    tilt();
    spotlight();
    counters();
    magnetic();
    progress();
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
